/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-08T12:53:04+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-05T10:08:20+02:00
*/

import React, {Component} from 'react';
import getDisplayName from './getDisplayName';

const BREAKPOINTS = {
  tiny: 0,
  mobile: 576,
  tablet: 768,
  desktop: 992,
  checkout: 1200,
  wide: 1200,
};

/**
 * MeasureBreakpoint - measures the screen size of the browser
 * and passes the breakpoint to a component.
 *
 * DEVNOTE: Do not use it too often. It is made for few simple cases.
 * If you like to use it for many components, connect it with a redux
 * store!
**/
function breakpointProp(WrappedComponent, breakpoints = BREAKPOINTS) {
  class MeasureBreakpoint extends Component {
    constructor(props) {
      super(props);
      this.running = false;
      this.smallesBreakpointName = this.findSmallestBreakpoint(breakpoints);
      this.state = {
        breakpoint: this.getBreakpointNameForWidth(window.innerWidth),
      };
    }

    componentDidMount() {
      window.addEventListener('resize', this.onResize);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
      this.cancelAnimationFrame();
    }

    render() {
      return (<WrappedComponent {...this.props} breakpoint={this.state.breakpoint} />);
    }

        onResize = () => {
          if (!this.running) {
            this.running = true;
            this.callOnAnimationFrame(this.measure);
          }
        }

        getSmallesBreakpointName() {
          return this.smallesBreakpointName;
        }

        getBreakpointNameForWidth(width) {
          const breakpointsArray = Object.entries(breakpoints);
          let currName = this.getSmallesBreakpointName();
          let currWidth = 0;
          breakpointsArray.forEach(([name, breakpoint]) => {
            if (breakpoint <= width && breakpoint > currWidth) {
              currWidth = breakpoint;
              currName = name;
            }
          });
          return currName;
        }

        callOnAnimationFrame(callback) {
          if (this.requestId) this.cancelAnimationFrame();
          if (window.requestAnimationFrame) {
            this.requestId = window.requestAnimationFrame(callback);
          } else {
            this.requestId = setTimeout(callback, 66);
          }
        }

        cancelAnimationFrame() {
          if (window.requestAnimationFrame) {
            window.cancelAnimationFrame(this.requestId);
          } else {
            clearTimeout(this.requestId);
          }
          this.requestId = null;
        }

        findSmallestBreakpoint(breakpointsProp) {
          let currName;
          let currWidth;
          const breakpointsArray = Object.entries(breakpointsProp);
          currName = breakpointsArray[0][0];
          currWidth = breakpointsArray[0][1];
          breakpointsArray.forEach(([name, breakpoint]) => {
            if (currWidth > breakpoint) {
              currWidth = breakpoint;
              currName = name;
            }
          });
          return currName; // smalles breakpoint
        }

        measure = () => {
          this.running = false;
          const name = this.getBreakpointNameForWidth(window.innerWidth);
          if (this.state.breakpoint !== name) {
            this.setState({breakpoint: name});
          }
        }
  }
  MeasureBreakpoint.propTypes = {
    /**
         * fired, when the breakpoint changes, passes the
         * new breakpoint name
         * @type {[type]}
         */
    // onChangeBreakpoint: PropTypes.func,
  };

  MeasureBreakpoint.displayName = `MeasureBreakpoint(${getDisplayName(WrappedComponent)})`;

  return MeasureBreakpoint;
}
export default breakpointProp;
